<nav class="animate__animated" *ngIf="menu_cliente == true" style="margin-top: 30px;">
    <ul style="line-height:280%">
        <div class="logo-new-simpli">
            <img routerLink="/home" src="../../assets/simpli/simpli.svg" height="70px" />
            <hr style="width: 90%; margin-top: 10px; border: none;  border-top: 2px solid #e4e4e4;">
        </div>
        
        
        

        <!--Inicio-->
        <li>
            <a  routerLink="/home">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <i class="fa-light fa-house material-simpli"></i>
                    </div>

                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                        <input value="Inicio" readonly class="sin-input">
                    </div>
                </div>
            </a>
        </li>

        <!--Mi cuenta-->
        <li>
            <a  routerLink="/home/info" routerLinkActive="router-link-active">

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <i class="fa-light fa-user-gear material-simpli"></i>
                    </div>

                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                        <input value="Mi cuenta" readonly class="sin-input">
                    </div>
                </div>
            </a>
        </li>

        <!--Ficha Inversionista-->
        <li>
            <a routerLink="/home/ficha-inversionista" routerLinkActive="router-link-active">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <i class="fa-light fa-id-card material-simpli"></i>
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                        <input value="Ficha" readonly class="sin-input">
                    </div>
                </div>
            </a>
        </li>

        <!--Cuentas Bancarias-->
        <!-- <li>
            <a routerLink="/home/cuentas-bancarias" routerLinkActive="router-link-active">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <i class="fa-light fa-building-columns material-simpli"></i>
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                        <input value="Cuentas bancarias" readonly class="sin-input">
                    </div>
                </div>
            </a>
        </li> -->

        <!--Simulacion-->
        <li>
            <a  routerLink="/home/simulacion" routerLinkActive="router-link-active">

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <i class="fa-light fa-chart-column material-simpli"></i>
                    </div>

                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                        <input value="Simulación" readonly class="sin-input">
                    </div>
                </div>
            </a>
        </li>

        <!--Cerrar Sesion-->
        <li>
            <a (click)="logout()" routerLinkActive="router-link-active">

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <i class="fa-light fa-arrow-right-from-bracket material-simpli"></i>
                    </div>

                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 texto-menu animate__animated">
                        <input value="Cerrar sesión" readonly class="sin-input">
                    </div>
                </div>
            </a>
        </li>


    </ul>
</nav>
